import { useEffect, useState } from "react";
import { Button, Modal } from "antd";
import { registerConfirmHost } from "./confirm";

// Móntalo una sola vez, en el shell global de la app.
// A partir de ahí, cualquier archivo puede llamar confirm({...}) importando "./confirm".
export default function ConfirmHost() {
  const [current, setCurrent] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => registerConfirmHost(setCurrent), []);

  if (!current) return null;

  const close = () => {
    if (loading) return;
    setCurrent(null);
  };

  const handleOk = async () => {
    try {
      setLoading(true);
      if (current.onOk) await current.onOk();
      setCurrent(null);
    } catch (e) {
      // el propio onOk ya debería notificar el error con notify.error(...)
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      open
      onCancel={close}
      centered
      maskClosable={!loading}
      closable={!loading}
      title={current.title}
      footer={[
        <Button key="cancel" onClick={close} disabled={loading}>
          {current.cancelText || "Cancelar"}
        </Button>,
        <Button key="ok" type="primary" danger={!!current.danger} loading={loading} onClick={handleOk}>
          {current.okText || "Aceptar"}
        </Button>,
      ]}
    >
      {current.content}
    </Modal>
  );
}
